import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchEstablishments } from '../services/api';

const ACCOMMODATION_URL = import.meta.env.VITE_ACCOMMODATION_URL
  || (window.location.hostname.includes('dev.') ? 'https://devhotel.dief360.com' : 'https://hebergement.dief360.com');

function statusBadge(status: string) {
  const s = (status || '').toLowerCase();
  const cls = s.includes('renouvel') || s.includes('expir') ? 'orange'
    : s.includes('valide') || s.includes('active') ? 'green'
    : 'gray';
  return <span className={`badge ${cls}`}>{status || '–'}</span>;
}

export default function EstablishmentsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchEstablishments()
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div className="card">
      <h3>Mes établissements</h3>
      <div className="sub">Seuls vos établissements sont visibles (isolation par compte).</div>
      <div className="table-wrap" style={{ marginTop: 16 }}>
        <table>
          <thead>
            <tr><th>Établissement</th><th>Activité</th><th>Catégorie</th><th>Licence</th><th>Durée</th><th>Expiration</th><th>Statut</th><th>Action</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={8} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucun établissement</td></tr>}
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{r.name || r.establishment_name || '–'}</td>
                <td>{r.activity || r.type || '–'}</td>
                <td>{r.category || r.star_rating || '–'}</td>
                <td>{r.license_number || '–'}</td>
                <td><strong>{r.license_duration || '12 mois'}</strong></td>
                <td>{r.expiration_date || r.license_expiry || '–'}</td>
                <td>{statusBadge(r.license_status || r.status)}</td>
                <td>
                  <button className="btn" onClick={() => navigate('/licenses')}>Voir fiche</button>
                  {(r.id || r.establishment_id) && (
                    <a
                      href={`${ACCOMMODATION_URL}/guests?hotel_id=${r.id || r.establishment_id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn"
                      style={{ marginLeft: 6 }}
                      title="Voir le profil sur le portail hébergement"
                    >
                      Hébergement ↗
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
